import allfragments from '../fragments/browser';

export const queryAllServices = `query getServiceForTeam(${allfragments.getServiceForTeam.variable}) {${allfragments.getServiceForTeam.query}}`;

export const getAllQueryInstances = `query queryInstances(${allfragments.getQueryInstances.variable}) {${allfragments.getQueryInstances.query}}`;

export const readMetricsValuesLineChart = `query queryInstances(${allfragments.readMetricsValues.variable}) {${allfragments.readMetricsValues.query}}`;

export const heatMapValues = `query queryBrowserErrorByCountries(${allfragments.heatMapValues.variable}) {${allfragments.heatMapValues.query}}`;

export const heatMapValuesCompare = `query queryBrowserErrorByCountries(${allfragments.heatMapValuesCompare.variable}) {${allfragments.heatMapValuesCompare.query}}`;

export const getErrorLogs = `query queryBrowserErrorLogs(${allfragments.getErrorLogs.variable}) {${allfragments.getErrorLogs.query}}`;

export const getErrorLog = `query queryBrowserErrorLog(${allfragments.getErrorLog.variable}) {${allfragments.getErrorLog.query}}`;

export const getErrors = `query queryBrowserErrorSummary(${allfragments.getErrors.variable}) {${allfragments.getErrors.query}}`;
